import React from 'react'
import PropTypes from 'prop-types'


export const Loader = ({ fullWidth = false, variant = 'primary', className = '', ...props }) => {

  const loader = (
    <div className={`spinner-border text-${variant} ${className}`} role="status" {...props}>
      <span className="visually-hidden">Loading...</span>
    </div>
  )


  if (!fullWidth) {
    return loader
  }

  return (
    <div className="w-100 text-center">
      {loader}
    </div>
  )
}


Loader.propTypes = {
  fullWidth: PropTypes.bool,
  variant: PropTypes.string,
  className: PropTypes.string,
}
